<p-toast position="bottom-right"></p-toast>
<p-confirmDialog
    header="Confirmation"
    [baseZIndex]="10000"
    icon="pi pi-exclamation-triangle"
>
</p-confirmDialog>
<div *ngIf="showLoader">
    <p-progressBar mode="indeterminate"
                   [style]="{'height': '6px'}"></p-progressBar>
</div>
<router-outlet></router-outlet>
